import { CHANCELLERIES_ENDPOINT } from 'common/constants'
import { request } from 'common/utils'

import query from '../graphql/getMatchableLocations.graphql'
import { GetMatchableLocationsQuery } from '../interfaces/schemaDefinition'

export const getMatchableLocations = async (chancelleryId: string): Promise<GetMatchableLocationsQuery['matchableLocations']> =>
  (await request<GetMatchableLocationsQuery>(CHANCELLERIES_ENDPOINT, query, { chancelleryId })).matchableLocations
